import request from '../utils/request'
export function APIRedeemCard(data) {
    return request({
      url: '/base/redeem/card',
      method: 'post',
      params: data
    });
}
/** 获取验证码 */
export function APICaptcha(data) {
    return request({
      url: '/base/api/captcha',
      method: 'get',
      params: data
    });
}
/** 查询物流单号 */
export function APIExpress(data) {
  return request({
    url: '/base/redeem/express',
    method: 'post',
    params: data
  });
}
/** 获取启用状态 */
export function APIValid(data) {
  return request({
    url: '/base/config/valid',
    method: 'get',
    params: data
  });
}